import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface BulkCheckoutPackagesRequest {
  ids: number[]
  comment?: string
}

export const bulkCheckoutPackages = async (data: BulkCheckoutPackagesRequest): Promise<void> => {
  await authAPI.put('/packages/bulk-checkout', data)
}

export const useBulkCheckoutPackages = () => {
  return useMutation({
    mutationFn: bulkCheckoutPackages,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
